import React, { Fragment, useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux';
import Box from '@mui/material/Box';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import { createTask } from '../../../common/api';
import { toast } from 'react-toastify';
import { formatDate } from '../../../common/utils';

import '../modals.css';

const AddTask = ( { close, uid, pPriority, pStatus, pType, pTeam, copy } ) => {
    const [ name, setName ] = useState();
    const [ details, setDetails ] = useState();
    const [ dueDate, setDueDate ] = useState();
    const [ priority, setPriority ] = useState();
    const [ assigned, setAssigned ] = useState();
    const [ status, setStatus ] = useState();
    const [ type, setType ] = useState();
    const [ ready, setReady ] = useState( false );
    const [ processing, setProcessing ] = useState( false );

    const nameRef = useRef( null );

    useEffect( () => {
        nameRef.current.focus();
    }, [] );

    useEffect( () => {
        console.log( copy );
        if ( copy ) {
            setName( genSmartName( copy.details.name ) );
            setDetails( copy.details.details );
            setPriority( copy.details.priority );
            setAssigned( copy.details.assignedTo );
            setType( copy.details.type );
        }
    }, [ copy ] );

    useEffect( () => {
        if ( name && name.length > 0 ) {
            setReady( true );
        } else {
            setReady( false );
        }
    }, [ name ] );

    useEffect( () => {
        const today = new Date();
        setDueDate( formatDate( today ) );
        // setPriority( pPriority.find( p => p.default ).value );
        // setAssigned( pTeam.find( p => p.default ).uid );
        setStatus( pStatus.find( p => p.default ).value );
        // setType( pType.find( p => p.default ).value );
    }, [ pPriority, pTeam, pStatus, pType ] );

    const genSmartName = ( name ) => {
        let n = name;

        const match = n.match( /Touch (\d+)\s?([-:].*)/ );
        if ( match ) {
            n = 'Touch ' + ( parseInt( match[1] ) + 1 ) + match[2];
        }

        return n;
    };

    const create = async () => {
        setProcessing( true );

        const t = {
            assignedTo: assigned,
            dueDate: dueDate,
            name: name,
            details: details,
            priority: priority,
            status: status,
            type: type
        };
        console.log( 't:', t );

        let assoc = [];
        copy.associations.forEach( a => {
            assoc.push( { label: 'cid', cid: a.cid } );
        } );
        console.log( 'assocs:', assoc );
        
        const added = await createTask( copy.details.aid, uid, t, assoc );
        if ( added.length ) {
            toast.success( `Follow-up task has been created`, { theme: 'dark' } );
            close();
            // window.location.reload( false );
        }
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '600px',
        bgcolor: 'background.paper',
        border: '1px solid #000',
        p: 2,
        maxHeight: '95vh',
        overflowY: 'auto'
    };

    return (
        <Fragment>
            <Box sx={ { ...style, pt: 0 } }>
                <Row className='py-2' style={ { borderBottom: '1px solid var( --bs-border-color )' } }>
                    <Col className='tf-modal-title'>Create a Follow-up Task</Col>
                </Row>
                {
                    processing ? (
                        <Fragment>
                            <Row className='py-3'>
                                <Col className='text-center'>
                                    <Spinner animation="border" variant='primary' role="status" />
                                </Col>
                            </Row>
                        </Fragment>
                    ) : (
                        <Fragment>
                            <Row className='py-2'>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Enter a brief description of this task</Form.Label>
                                        <Form.Control ref={nameRef} className='tf-modal-text-input' type="text" placeholder="Task Description" value={name} onChange={ ( e ) => setName( e.target.value ) } />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-2'>
                                <Col xs='auto'>
                                    <Form.Group>
                                        <Form.Label>Due date for this task</Form.Label>
                                        <Form.Control className='tf-modal-text-input' type="date" value={dueDate} onChange={ ( e ) => setDueDate( e.target.value ) } />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-2'>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Type of task</Form.Label>
                                        <Form.Select size='sm' className='tf-modal-text-input' value={type} onChange={ ( e ) => setType( e.target.value ) }>
                                            {
                                                pType.map( ( p, idx ) => <option key={idx} value={p.value}>{p.label}</option>)
                                            }
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Status of this task</Form.Label>
                                        <Form.Select size='sm' className='tf-modal-text-input' value={status} onChange={ ( e ) => setStatus( e.target.value ) }>
                                            {
                                                pStatus.map( ( p, idx ) => <option key={idx} value={p.value}>{p.label}</option>)
                                            }
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Priority for this task</Form.Label>
                                        <Form.Select size='sm' className='tf-modal-text-input' value={priority} onChange={ ( e ) => setPriority( e.target.value ) }>
                                            {
                                                pPriority.map( ( p, idx ) => <option key={idx} value={p.value}>{p.label}</option>)
                                            }
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-2'>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Any specific details needed for this task</Form.Label>
                                        <Form.Control as='textarea' rows={3} className='tf-modal-text-input' placeholder="Specific details..." value={details} onChange={ ( e ) => setDetails( e.target.value ) } />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-2'>
                                <Col xs='auto'>
                                    <Form.Group>
                                        <Form.Label>Assign it to</Form.Label>
                                        <Form.Select size='sm' className='tf-modal-text-input' value={assigned} onChange={ ( e ) => setAssigned( e.target.value ) }>
                                            {
                                                pTeam.map( ( p, idx ) => <option key={idx} value={p.uid}>{p.name}</option>)
                                            }
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-2'>
                                <Col xs='auto'>
                                    <Button size='sm' variant='outline-primary' onClick={ () => create() } disabled={!ready}>Create</Button>
                                </Col>
                                <Col xs='auto'>
                                    <Button size='sm' variant='outline-primary' onClick={ () => close() }>Cancel</Button>
                                </Col>
                            </Row>
                        </Fragment>
                    )
                }
            </Box>
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    // aid: state.user.aid,
    uid: state.user.email,
    pPriority: state.user.meta.global.picklist.priority,
    pStatus: state.user.meta.task.picklist.status,
    pType: state.user.meta.task.picklist.type,
    pTeam: state.user.lists.team
} );
  
const mapDispatch = ( dispatch ) => ( {
    // load: dispatch.lists.loadGroups,
} );
  
export default connect( mapProps, mapDispatch )( AddTask );